export default "__VITE_ASSET__738a8dc5__"